(function () {
  'use strict'

  // Prevent default
  // ----------------------------------------
  $( '.preventDefault' ).bind('click', function(e) {
    e.preventDefault()
  })
})()
